<template>
  <span>
    <v-row v-for="(item, index) of items" :key="index">
      <v-col>
        <div v-if="!isTable(item)">
          <v-row>
            <v-col>
              <div class="confirm-field-title">{{ item.title }}</div>
            </v-col>

            <v-spacer />

            <v-btn :disabled="submitting" @click="() => setStep(item.step)" text
              >Edit</v-btn
            >
          </v-row>

          <div v-for="(line, i) of item.lines" :key="`${line}-${i}`">
            <span v-if="line !== ''">{{ line }} </span>
            <br v-else />
          </div>
        </div>
        <v-col class="pt-0 pb-0" v-else>
          <v-row
            v-for="(row, rowIndex) of [item.title, ...item.lines]"
            :key="rowIndex"
            class="pa-0"
            :style="{ flexWrap: 'nowrap' }"
          >
            <v-col
              class="pa-0"
              :cols="12 / (item.title.length + 1)"
              v-for="col of row"
              :key="col"
            >
              <span :class="{ 'confirm-field-title': rowIndex === 0 }">{{
                col
              }}</span>
            </v-col>

            <v-col class="pa-0">
              <v-btn
                v-if="rowIndex === 0"
                :style="{ float: 'right' }"
                :disabled="submitting"
                @click="() => setStep(item.step)"
                text
                >Edit</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-col>

      <Divider :no-margins="true" color="gray" :style="{ width: '96%' }" />
    </v-row>
  </span>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapMutations } from "vuex";
import Divider from "./Divider";

export default {
  name: "ConfirmationColumn",

  props: ["items", "submitting"],

  components: {
    Divider
  },

  methods: {
    ...mapMutations("step", ["setStep"]),

    isTable(item) {
      if (_.isArray(item.title)) {
        return true;
      }

      return false;
    }
  }
};
</script>

<style scoped>
.confirm-field-title {
  font: normal normal 900 16px/19px Lato;
  letter-spacing: 0px;
  color: #333333;
  text-transform: uppercase;
}
</style>
